// The rig that owns the body clips right now, for code reaching the body by value.
// Notes: ~/comments/aos-threejs-poc/liveBodyRig_two_rigs_can_be_the_body.md

let _rig = null
// A generated clip BAKES against the rig, so the rig has to exist before the clip
// does — but the multipart splat only mounts its part drive for a graph that asks
// for it (an authored body blueprint) or a preview already holding __DIRECT_PLAY__.
// A character whose body graph is bare — one that ships `finalPose` alone — had
// neither, so every generated walk/gesture died on 'avatar scene not ready' with no
// way to ask for the rig it needed. This is that ask.
let _wanted = false
let _waiters = []

/** `{scene, restPose, rigToWorld, rigToWorldScale, register(name, clip, {additive}),
 *  clipDuration(name)}`, where `rigToWorldScale` is metres per rig unit,
 *  or null on teardown. `additive` says the clip arrives as deltas, not a full pose. */
export function setLiveBodyRig(rig) {
  _rig = rig || null
  if (typeof window !== 'undefined') window.__LIVE_BODY_RIG__ = _rig
  if (!_rig) {
    // Teardown: the demand belonged to the character that just went away, so the
    // next one attaches on its own terms rather than inheriting a download.
    _wanted = false
    return
  }
  const waiters = _waiters
  _waiters = []
  for (const resolve of waiters) resolve(_rig)
}

export function getLiveBodyRig() {
  return _rig
}

/** Whether something has asked for the body rig to be mounted. Read by the rig's
 *  owner (MultipartOGSModel) alongside its own reasons to attach. */
export function isLiveBodyRigWanted() {
  return _wanted
}

/**
 * Ask for the live body rig and wait for it, for code that must BUILD a clip
 * against it. Resolves the rig, or null when this avatar has no such rig to wait
 * for — a GLB avatar owns the body through `__AVATAR_SCENE__` and declares nothing
 * here, and with no splat drive mounted there is nobody to serve the demand.
 * A timeout resolves null too: the caller's own "scene not ready" error is the
 * loud one, and it names the thing that is actually missing.
 */
export function ensureLiveBodyRig({ timeoutMs = 20000 } = {}) {
  if (_rig) return Promise.resolve(_rig)
  const w = typeof window !== 'undefined' ? window : null
  if (w?.__AVATAR_SCENE__) return Promise.resolve(null)
  if (!w?.__MULTIPART_DRIVE__) return Promise.resolve(null)
  _wanted = true
  return new Promise((resolve) => {
    let timer = null
    const settle = (rig) => {
      if (timer === false) return
      if (timer) clearTimeout(timer)
      timer = false
      resolve(rig)
    }
    _waiters.push(settle)
    timer = setTimeout(() => {
      console.warn(`[liveBodyRig] the body rig did not attach within ${timeoutMs} ms`)
      timer = null
      settle(null)
    }, timeoutMs)
  })
}
